import React from 'react';

const BottomNav = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'balance', icon: '💰', label: 'Guthaben', action: 'recharge' },
    { id: 'round', icon: '🎉', label: 'Runde', action: 'gift' },
    { id: 'home', icon: '🍺', label: 'Home', action: 'home' },
    { id: 'history', icon: '📜', label: 'Historie', action: 'history' },
    { id: 'account', icon: '👤', label: 'Konto', action: 'account' }
  ];

  return (
    <nav className="fixed left-1/2 bottom-4 transform -translate-x-1/2 z-50">
      <div className="bottom-nav-container flex items-center justify-between px-4 relative">
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.action)}
            className={`tab-button transition-all duration-200 ${
              tab.id === 'home' 
                ? 'relative z-10' 
                : 'flex-1'
            }`}
          >
            {tab.id === 'home' ? (
              // FAB für Home Button - größer
              <div className={`w-20 h-20 md:w-24 md:h-24 rounded-full flex items-center justify-center shadow-glow-accent transition-all duration-200 ${
                activeTab === 'home' 
                  ? 'bg-accent-1 text-text-strong scale-110' 
                  : 'bg-accent-1 text-text-strong hover:bg-accent-2 hover:scale-105'
              }`}>
                <span className="text-2xl md:text-3xl">{tab.icon}</span>
              </div>
            ) : (
              // Normale Tab Buttons - größere Icons
              <div className={`flex flex-col items-center justify-center transition-all duration-200 ${
                activeTab === tab.action 
                  ? 'text-text-strong' 
                  : 'text-text-subtle hover:text-text-normal'
              }`}>
                <span className="text-xl md:text-2xl">{tab.icon}</span>
                <span className="text-xs font-medium hidden sm:block">{tab.label}</span>
                
                {/* Aktive States für alle Tabs - feste Position */}
                <div className={`w-full h-1 rounded-full transition-all duration-200 ${
                  activeTab === tab.action 
                    ? (tab.action === 'history' || tab.action === 'account' 
                        ? 'bg-accent-2' 
                        : 'bg-accent-1')
                    : 'bg-transparent'
                }`}></div>
              </div>
            )}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
